import React from 'react';
import { List, Brain, ChefHat } from 'lucide-react';
import { IMAGES } from '../i18n';

const ICONS = [List, Brain, ChefHat];

const HowItWorks = ({ t }) => {
  return (
    <section id="section-3" className="py-20 bg-gradient-to-br from-green-50 to-emerald-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-ink mb-4">{t.title}</h2>
          <p className="text-lg sm:text-xl text-slate-600 max-w-3xl mx-auto">{t.subtitle}</p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-green-200 transform -translate-y-1/2 z-0" />

          <div className="grid lg:grid-cols-3 gap-8 relative z-10">
            {t.steps.map((step, index) => {
              const Icon = ICONS[index];
              return (
                <div key={index} className="text-center">
                  <div className="relative mb-8 inline-block">
                    <div className="w-24 h-24 bg-white rounded-full shadow-lg flex items-center justify-center mx-auto relative z-10">
                      <Icon className="w-10 h-10 text-primary" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-accent text-white rounded-full flex items-center justify-center text-sm font-bold">
                      {step.number}
                    </div>
                  </div>
                  <h3 className="text-xl font-semibold text-ink mb-4">{step.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{step.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="relative inline-block max-w-md w-full">
            <img
              src={IMAGES.howItWorks}
              alt={t.imageAlt}
              className="w-full rounded-2xl shadow-2xl object-cover max-h-[480px]"
              loading="lazy"
            />
            <div className="absolute -bottom-4 -right-2 sm:-right-4 bg-primary text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg">
              {t.badge}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
